import React, { useCallback } from 'react'

import styles from './Checkbox.module.css'

const Checkbox = ({ title, label, checked, onChange, hideContainer }) => {
  const onClick = useCallback((newValue) => () => onChange(newValue), [
    onChange,
  ])
  return (
    <div className={hideContainer ? null : styles.container}>
      <div className={styles.title}>{title}</div>
      <div className={styles.body}>
        <span
          className={
            checked ? `${styles.option} ${styles.selected}` : styles.option
          }
          onClick={onClick(!checked)}
        >
          {checked ? (
            <i className="fa fa-check-square"></i>
          ) : (
            <i className="far fa-square"></i>
          )}{' '}
          {label}
        </span>
      </div>
    </div>
  )
}

export default Checkbox
